// Debug utility for auth issues
export const debugAuth = {
  log: (message, data = null) => {
    if (process.env.NODE_ENV === 'development' || window.location.search.includes('debug=true')) {
      console.log(`[AUTH DEBUG] ${message}`, data || '');
    }
  },
  
  checkToken: () => {
    const token = localStorage.getItem('token');
    if (!token) {
      debugAuth.log('No token in localStorage');
      return false;
    }
    
    try {
      const parts = token.split('.');
      const payload = JSON.parse(atob(parts[1]));
      const exp = new Date(payload.exp * 1000);
      const now = new Date();
      
      debugAuth.log('Token check:', {
        payload,
        expiresAt: exp.toISOString(),
        currentTime: now.toISOString(),
        isExpired: exp < now,
        minutesRemaining: ((exp - now) / 1000 / 60).toFixed(2)
      });
      
      return exp > now;
    } catch (e) {
      debugAuth.log('Error decoding token:', e);
      return false;
    }
  }
};

window.debugAuth = debugAuth; // Make it available in console